export default __webpack_public_path__ + "static/media/ranking-level-dropped-step2.965ced2d.png";